import { invokeEdgeJson } from "@/lib/api/edge-invoke";

export type ListingDomainSyncResult = {
  success?: boolean;
  code?: string;
  error?: string;
  dry_run?: boolean;
  results?: Array<{
    listing_id: string;
    provider: string;
    domains: Record<string, { status: string; reason?: string; before?: unknown; after?: unknown; intended?: unknown }>;
  }>;
  message?: string;
};

export function retireCatalogueProduct(params: {
  orgId: string;
  productId: string;
}): Promise<{ success: boolean; data: ListingDomainSyncResult | null; error?: string }> {
  return invokeEdgeJson<ListingDomainSyncResult>("catalogue-variant-retirement", {
    org_id: params.orgId,
    product_id: params.productId,
    scope: "product",
  });
}

export function retireSelectedVariant(params: {
  orgId: string;
  variantId: string;
}): Promise<{ success: boolean; data: ListingDomainSyncResult | null; error?: string }> {
  return invokeEdgeJson<ListingDomainSyncResult>("catalogue-variant-retirement", {
    org_id: params.orgId,
    variant_id: params.variantId,
  });
}

export function syncListingDomains(params: {
  orgId: string;
  productId?: string;
  listingId?: string;
  domains: string[];
  dryRun?: boolean;
}): Promise<{ success: boolean; data: ListingDomainSyncResult | null; error?: string }> {
  return invokeEdgeJson<ListingDomainSyncResult>("listing-domain-sync", {
    org_id: params.orgId,
    product_id: params.productId,
    listing_id: params.listingId,
    domains: params.domains,
    dry_run: params.dryRun === true,
    mode: params.dryRun === true ? "DRY_RUN" : "LIVE",
  });
}
